export const subscriptionJobValueMultiplier: number = 1_000_000;

export const maxFileSizeMB: number = 10;
export const payInSlipExtension: string = '.jpg, .jpeg, .png';
export const withholdingTaxExtension: string = '.jpg, .jpeg, .png, .pdf';
export const maxFileSizeUnit: string = 'MB';

export enum ConsentType {
  SIGNED_CONSENT = 'signed_consent',
  COMPANY_REGISTRATION = 'company_registration',
  BUSINESS_REGISTRATION_CERTIFICATE = ' business_registration_certificate',
  COPY_OF_ID_CARD = 'copy_of_id_card',
  POWER_OF_ATTORNEY = 'power_of_attorney',
  OTHER_FILE = 'other_file',
}
